import {html} from 'lit';

export function opinary(iframeUrl: string) {
  return html`<iframe scrolling="no" class="eesb" src="${iframeUrl}" sandbox="allow-popups allow-same-origin allow-scripts"></iframe>`;
}
